ApproveRejectPaymentController.$inject = ['$scope', '$modalInstance', 'type'];

export default function ApproveRejectPaymentController($scope, $modalInstance, type) {
    $scope.type = type;
    // this will dismiss the window.

    $scope.cancel = function () {
        $modalInstance.dismiss();
    };

    $scope.save = function () {
        $modalInstance.close($scope.comments);
    };
}
